FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};
    var hubProxy;
    var options = {};
    var defaults = {
        hubName: null,
        functionList: null
    };


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    child.setWebSocket = function (userOptions) {
        options = $.extend({}, defaults, userOptions);
        if (!options.hubName) {
            window.console && console.error("Error opening web socket: connection name is required.");
            return;
        } else if (!options.functionList || !options.functionList.length) {
            window.console && console.error("Error opening web socket: function list is empty.");
            return;
        }
        hubProxy = $.connection[options.hubName];
        for (var x = 0; x < options.functionList.length; x++) {
            hubProxy.client[options.functionList[x].name] = options.functionList[x].function;
        }

        return $.connection.hub.start();
    };


    // Should only call this once we're sure the connection is open.
    // Usually - this will look something like:
    // me.CONTROL.setWebSocket(options).done(function () {
    //      localHubVariable = me.CONTROL.getConnectionHub();
    // });
    child.getConnectionHub = function () {
        return hubProxy;
    };

    return child;
}(jQuery, FD));